import { Method } from "../../data/DataUtils.js";
import * as DataUtils from "../../data/DataUtils.js";
import * as DTOs from "../DTOs/PersonaParientesDTOs.js";

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    "personas/" + idPadre + "/parientes/" + idItem,
    null
  );
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject("personas/" + idPadre + "/parientes/" + idItem);
};

export const GetListaItems = async (idPadre) => {
  return DataUtils.FetchLista("personas/" + idPadre + "/parientes");
};

export const PostItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.POST,
    "personas/" + idPadre + "/parientes",
    DTOs.saveItem(datosItem)
  );
};

export const PutItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.PUT,
    "personas/" + idPadre + "/parientes/" + datosItem.id,
    DTOs.saveItem(datosItem)
  );
};
